import { render, staticRenderFns } from "./TipModal.vue?vue&type=template&id=6f60357e&scoped=true&"
import script from "./TipModal.vue?vue&type=script&lang=js&"
export * from "./TipModal.vue?vue&type=script&lang=js&"
import style0 from "./TipModal.vue?vue&type=style&index=0&id=6f60357e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f60357e",
  null
  
)

export default component.exports